export function normalizeError(error: unknown): string {
  if (error == null || error === '') {
    return '';
  }

  if (error instanceof Error) {
    return error.message || error.toString() || '';
  }

  if (typeof error === 'object') {
    try {
      const serialized = JSON.stringify(error);
      return serialized === '{}' ? '' : serialized;
    } catch {
      return '[Unserializable error object]';
    }
  }

  if (
    typeof error === 'string' ||
    typeof error === 'number' ||
    typeof error === 'boolean'
  ) {
    const stringified = String(error);
    return stringified === 'undefined' || stringified === 'null'
      ? ''
      : stringified;
  }

  return '';
}
